import Link from 'next/link';
import { memo } from 'react';

export const Privacy = memo(() => {
  return (
    <>
      You can unsubscribe from marketing communications at any time.
      <br />
      You can find out more about how to unsubscribe in our <Link href="/privacy">Privacy Policy</Link>.<br />
      Your preferences also include offers and news from other subsidiaries of Shell such as Shell Recharge Solutions
      and Shell Energy Europe Ltd.
    </>
  );
});

Privacy.displayName = 'Privacy';
